const isAssetImageChecker = (fileExtension) => {
  const fileExtensionCheck = (fileExtension || '').toLowerCase();
  return ['jpg', 'jpeg', 'png', 'bmp', 'svg', 'webp', 'heic', 'gif'].includes(fileExtensionCheck);
};

export default isAssetImageChecker;
